import React, { Component } from 'react';
import ReactMapboxGl, { Layer, Source } from "react-mapbox-gl";
// import base from '../base';

// import geojson from '../brooklyn.json';
import IRC from '../indian_river.json';
import greenpoint from '../greenpoint.json';
import lexington from '../lexington.json';
import atlanta from '../atlanta.json';
import droga from '../droga.json';
import markers from '../markers.js';
import backgrounds from '../backgrounds.js';
import navigation from '../navigation.js';





const MapBox = ReactMapboxGl({
  accessToken: process.env.REACT_APP_ACCESS_TOKEN,
  scrollZoom: false,
  dragRotate: false,
  doubleClickZoom: false,
  touchZoomRotate: false,
  dragPan: false
});



class Map extends Component {
	constructor(props) {
	  super(props);


		this.state = {
	   		center:[-73.96721951876916 , 40.7366044999703],
	   		zoom : [13.36],
	   		zoomAdjusted:null,
	   		enableZoom: false,
		}
	}
	
	

	componentWillReceiveProps(nextProps) {
		const {jumpTo, educationJump, navContent, isMobile} = nextProps;
		console.log(this.state.center)
		// console.log(this.props)
		if(jumpTo !== this.props.jumpTo ){

			this.map.jumpTo({ 
				center: jumpTo.coords,
				zoom: jumpTo.zoom
			})
		}

		if(educationJump !== this.props.educationJump) {
			this.map.jumpTo({
				center: educationJump.coordinates,
				zoom: educationJump.zoom
			})


		}



		// if(isMobile !== this.props.isMobile && isMobile === true) {
		// 	console.log(navigation[0].mobileCoordinates)
		// 	this.map.setCenter(navigation[0].mobileCoordinates)
		// }

		if(navContent !== this.props.navContent) {
			// console.log(navContent)
			let {navTitle } = navContent;
			let buttons = markers.filter(marker =>{
				return marker.type === "button";
			})

			// console.log(navTitle)
			// console.log(buttons);
			if(navTitle === 'Work') {
				// console.log('it happened')
				buttons.map(button => {
					

					this.map.on('render', button.id, (e) => {
			 			this.map.setPaintProperty(button.id, 'icon-opacity', 1);
			 	    });
				})
				
			} else if(navTitle==='Home'){
				return
			}else {
				buttons.map(button => {
		 			this.map.setPaintProperty(button.id, 'icon-opacity', 0);
				})
			}
			
		}

	}



	componentWillUpdate(nextProps, nextState) {
		

		if(nextState.enableZoom === true) {
			this.map.scrollZoom.enable({ around: 'center' })
		}
	}



	disableZoom () {
		this.setState({
			enableZoom: false
		})
	}
	activateZoom () {
		this.setState({
			enableZoom: true
		})
	}



	render(){

		let greenpointSource = {
			"type": "geojson",
		  	"data": greenpoint
		};
		let drogaSource = {
			"type": "geojson",
			"data": droga
		}

		let veroSource = {
			"type": "geojson",
			"data": IRC
		}
		let lexingtonSource = {
			"type": "geojson",
			"data": lexington
		}

		let atlantaSource = {
			"type": "geojson",
			"data": atlanta
		}



		return(
			
			<MapBox
			  	style="mapbox://styles/bfmcgo2/cje1yog8zc5xi2rq99geum951"
			   	className = "BradMap"
				containerStyle={{
			    height: "100vh",
			    width: "100vw",
			    position: "fixed",
			    top: 0,
			    left: 0
			 	}}

				center= {this.state.center}
				zoom = {this.state.zoom}
				onMouseMove = {(map, coord) => {
					if(this.map){
						let updatedZoom =this.map.getZoom()
						this.setState({
							zoomAdjusted: updatedZoom
						})
					}
					this.props.coordinatesValue(coord.lngLat, this.state.zoomAdjusted)
				}}



		  		onStyleLoad={map => {
			  	  	this.map = map;
			  	  	this.props.renderComponents();

		  	  		if(this.props.isMobile){
		  	  			this.map.jumpTo({
		  	  				zoom: [13]
		  	  			})
		  	  		}

			  	  
  	// Loop through Markers
					map.on('dblclick', (e) => {
						// console.log(e)
						this.props.coordArray([e.lngLat.lng, e.lngLat.lng])
					})


					markers.map(marker => {
				  		let {
				  			id, 
				  			coordinates, 
				  			imgSrc, 
				  			iconRotate,
				  			iconOffset, 
				  			iconSize,
				  			mobileIconSize, 
				  			locationLabel,
				  			zoom, 
				  			mobileZoom,
				  			socialUrl, 
				  			iconOpacity, 
				  			locationTitle,
				  			titleOpacity, 
				  			flyTo, 
				  			zoomTo,
				  			content,
				  			type,
				  			mobileCoordinates
				  		} = marker;



				  		const logo = imgSrc;
  			  		  	map.loadImage(imgSrc, (error, image) => {
  			  		  		if (error) throw error;
  			  		  		map.addImage(id, image);
  			  		  		

  			  		  	

  			  		  	if(mobileCoordinates && this.props.isMobile){
  		  	  		  	  	map.addLayer({
  		  	  	  	  	       "id": id,
  		  	  	  	  	       "type": "symbol",
  		  	  	  	  	       "source": {
  		  	  	  	  	       		"type": "geojson",
  		  	  	  	  	       		"data":{
  		  	  	       					"type": "FeatureCollection",
  		  	  	       					"features": [{
  		  	  	       			    		"type": "Feature",
  		  	  	       			    		"geometry": {
  		  	  	       			        		"type": "Point",
  		  	  	       			        		"coordinates": mobileCoordinates
  		  	  	       			    		},
  		  	  	       			    		"properties": {
			    		                        "title": locationTitle,
   			    		                    }
  		  	  	       					}]
  		  	  	  	  	       		}
  		                		},
  		  	  	  	  	       "layout": {
  		  	  	  	  	       		"icon-image": id,
  		  	  	  	  	       		"icon-size": mobileIconSize,
  		  	  	  	  	       		"icon-allow-overlap": true,
  		  	  	  	  	       		"icon-rotate": iconRotate,
  	  	  	       		            "text-field": "{title}",
  	  	  	       		            "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
  	  	  	       		            "text-offset": [0, 6],
  	  	  	       		            "text-anchor": "top"
  		  	  	  	  	       },
  		  	  	  	  	       "paint":{
  		  	  	  	  	       		"icon-opacity":iconOpacity,
  		  	  	  	  	       		"text-opacity":titleOpacity
  		  	  	  	  	       }
  		  	  	  	  	   });
  			  		  	} else {
  		  	  		  	  	map.addLayer({
  		  	  	  	  	       "id": id,
  		  	  	  	  	       "type": "symbol",
  		  	  	  	  	       "source": {
  		  	  	  	  	       		"type": "geojson",
  		  	  	  	  	       		"data":{
  		  	  	       					"type": "FeatureCollection",
  		  	  	       					"features": [{
  		  	  	       			    		"type": "Feature",
  		  	  	       			    		"geometry": {
  		  	  	       			        		"type": "Point",
  		  	  	       			        		"coordinates": coordinates
  		  	  	       			    		},
  		  	  	       			    		"properties": {
			    		                        "title": locationTitle,
   			    		                    }
  		  	  	       					}]
  		  	  	  	  	       		}
  		                		},
  		  	  	  	  	       "layout": {
  		  	  	  	  	       		"icon-image": id,
  		  	  	  	  	       		"icon-size": iconSize,
  		  	  	  	  	       		"icon-allow-overlap": true,
  		  	  	  	  	       		"icon-rotate": iconRotate,
  	  	  	       		            "text-field": "{title}",
  	  	  	       		            "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
  	  	  	       		            "text-offset": [0, 6],
  	  	  	       		            "text-anchor": "top"
  		  	  	  	  	       },
  		  	  	  	  	       "paint":{
  		  	  	  	  	       		"icon-opacity":iconOpacity,
  		  	  	  	  	       		"text-opacity":titleOpacity
  		  	  	  	  	       }
  		  	  	  	  	   });
  			  		  	}
  		  	  		  	  	


  		  	  		  	  	map.on('mouseenter', id, function(e) {
  		  	  		  	  	       // Change the cursor style as a UI indicator.
  		  	  		  	  	       map.getCanvas().style.cursor = 'pointer';
  		  	  		  	  	})
  		  	  		  	  	map.on('mouseleave', id, function() {
	  	  		  	  	        map.getCanvas().style.cursor = '';
	  	  		  	  	    });

  		  	  		  	  	if(socialUrl){
  		  	  		  	  		map.on('click', id, function(){
  		  	  		  	  			window.open(socialUrl, "_blank");
  		  	  		  	  		})
  		  	  		  	  	}

  		  	  		  	  	if(flyTo){
  		  	  		  	  		map.on('click', id,  function(e){
  		  	  		  	  			map.flyTo({ 
  		  	  		  	  				center: flyTo,
  		  	  		  	  				zoom: zoomTo,
  		  	  		  	  				speed: 0.5,
  		  	  		  	  				curve: 1
  		  	  		  	  			})

  		  	  		  	  		});
  		  	  		  	  	}

  		  	  		  	  	if(content) {

  		  	  		  	  		map.on('click', id, (e) => {
  		  	  		  	  			console.log(content)
  		  	  		  	  			this.props.getWorkContent(content.work);
  		  	  		  	  		})
  		  	  		  	  	}
	  	  		  	  	    
  		  	  		  	  	

  	  		  		  	 	map.on('move', () => {
  		  		  	 			let currentZoom = map.getZoom();
  		  		  	 			// console.log(this.props);
  		  		  	 			
  		  		  	 			let { isMobile } = this.props

  		  		  	 			if(isMobile) {
			  		  	 			if(currentZoom < mobileZoom) {
		  		  		  	 			map.setLayoutProperty(id, 'icon-size', 0);
		  		  		  	 			map.setPaintProperty(id, 'text-opacity', 0);
			  		  	 			} else {
			  		  	 				map.setLayoutProperty(id, 'icon-size', mobileIconSize);
			  		  	 			}
  		  		  	 			}else {
			  		  	 			if(currentZoom < zoom) {
		  		  		  	 			map.setLayoutProperty(id, 'icon-size', 0);
		  		  		  	 			map.setPaintProperty(id, 'text-opacity', 0);
			  		  	 			} else {
			  		  	 				map.setLayoutProperty(id, 'icon-size', iconSize);
			  		  	 			}
  		  		  	 			}

		  		  	 			

  		  		  	 			
  		  		  	 	    });
  		  	  		  	  	
  		  	  		  	  	

  		  	  		  	  
  			  		  	})

					})

		// END LOOP
					



			  	  }
		  		}

		  	>
			    	
		  		<Source 
			  		id='greenpoint' 
			  		geoJsonSource={greenpointSource} />

				<Layer 
					id="greepoint-overlay"
					sourceId='greenpoint'
					type='fill'
					paint={{
						"fill-color":"#999898",
						"fill-opacity": 0.5
					}}
					filter={["==", "$type", "Polygon"]} />

		  		<Source 
			  		id='droga5' 
			  		geoJsonSource={drogaSource} />

				<Layer 
					id="droga5-overlay"
					sourceId='droga5'
					type='fill'
					paint={{
						"fill-color":"#00baff",
						"fill-opacity": 1,
						"fill-opacity-transition": {
						        delay: 1000
						    }
					}}
					filter={["==", "$type", "Polygon"]} />	

		  		<Source 
			  		id='vero' 
			  		geoJsonSource={veroSource} />

				<Layer 
					id="vero-overlay"
					sourceId='vero'
					type='fill'
					paint={{
						"fill-color":"#f56f16",
						"fill-opacity": 0.8
					}}
					filter={["==", "$type", "Polygon"]} />				
				<Source 
			  		id='lexington' 
			  		geoJsonSource={lexingtonSource} 
			  		onSourceAdded= {source =>{

			  		}}/>

				<Layer 
					id="lexington-overlay"
					sourceId='lexington'
					type='fill'
					paint={{
						"fill-color":"#0033a0",
						"fill-opacity": 0.8,
					}}
					filter={["==", "$type", "Polygon"]} />


				<Source 
			  		id='circus' 
			  		geoJsonSource={atlantaSource} 
			  		onSourceAdded= {source =>{

			  		}}/>

				<Layer 
					id="circus-overlay"
					sourceId='circus'
					type='fill'
					paint={{
						"fill-color":"#D71F26",
						"fill-opacity": 0.8,
					}}
					filter={["==", "$type", "Polygon"]} />



			</MapBox>
	
	
		)
	}
}

export default Map;


// WEBPACK FOOTER //
// ./src/pages/Map.js